<template>
  <v-data-table
    id="table-frame"
    ref="table-frame"
    :headers="headers"
    :items="items"
    hide-actions
    no-data-text="Нет данных"
    style="height: 100%"
    class="v-data-table--fixed-header v-data-table--fixed-footer"
  >
    <DataTableProgressLine
      v-if="itemsLoading"
      :items-length="headers.length"
    />
    <template
      slot="headers"
      slot-scope="props"
    >
      <tr>
        <th
          v-for="header in props.headers"
          :key="header.text"
        >
          <span v-if="header.type === 'icon'">
            <v-btn
              small
              icon
              class="ma-0"
              :disabled="isItemsWithCategory || disabled"
              data-test="addCategoriesInfo"
              @click="addItem(header)"
            >
              <v-icon color="grey">{{ header.value }}</v-icon>
            </v-btn>
          </span>
          <span>{{ header.text }}</span>
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <td>
        <v-tooltip
          v-if="props.item.category"
          top
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <Reference
                v-model="props.item.category"
                resource="product-categories"
                :disable-add="true"
                :outline="false"
                :height-field="26"
                data-test="productCategories"
                :disabled="disabled"
                @input="handleItemChange(props.item)"
              />
            </span>
          </template>
          <span>{{ props.item.category.title }}</span>
        </v-tooltip>
        <Reference
          v-else
          v-model="props.item.category"
          resource="product-categories"
          :disable-add="true"
          :outline="false"
          :height-field="26"
          data-test="productCategories"
          :disabled="disabled"
          @input="handleItemChange(props.item)"
        />
      </td>
      <td>
        <DecimalEditor
          v-model="props.item.weightBrutto"
          :available-zero="true"
          :scale="3"
          :outline="false"
          :height-field="26"
          data-test="weightBrutto"
          :disabled="disabled"
          @input="handleItemChange(props.item)"
        />
      </td>
      <td>
        <DecimalEditor
          v-model="props.item.volume"
          :available-zero="true"
          :scale="3"
          :outline="false"
          :height-field="26"
          data-test="volume"
          :disabled="disabled"
          @input="handleItemChange(props.item)"
        />
      </td>
      <td>
        <DecimalEditor
          v-model="props.item.cargoPlaces"
          :available-zero="true"
          :scale="3"
          :outline="false"
          :height-field="26"
          data-test="cargoPlaces"
          :disabled="disabled"
          @input="handleItemChange(props.item)"
        />
      </td>
      <td>
        <v-menu
          offset-y
          :open-on-hover="true"
          :disabled="disabled"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              class="ma-0"
              data-test="rowActionsMenu"
              v-on="on"
            >
              <v-icon color="grey">
                more_vert
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="deleteItems(props.item)">
              <v-list-tile-content>
                <v-layout align-center>
                  <v-icon
                    small
                    outline
                    color="grey lighnen-1"
                    class="mr-1"
                    data-test="deleteCategoriesInfo"
                  >
                    delete
                  </v-icon>
                  <span>Удалить</span>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </template>
    <template slot="footer">
      <td class="footer-table-cell">
        <strong>Итого:</strong>
      </td>
      <td
        :class="[
          'footer-table-cell',
          isDifferentSumOfWeightBrutto ? 'red--text' : ''
        ]"
      >
        {{
          $options.filters.separateDigits(
            sumOfWeightBrutto.toFixed("3").replace(".", ",")
          )
        }}
      </td>
      <td
        :class="[
          'footer-table-cell',
          isDifferentSumOfVolume ? 'red--text' : ''
        ]"
      >
        {{
          $options.filters.separateDigits(
            sumOfVolume.toFixed("3").replace(".", ",")
          )
        }}
      </td>
      <td
        :colspan="2"
        :class="[
          'footer-table-cell',
          isDifferentSumOfCargoPlaces ? 'red--text' : ''
        ]"
      >
        {{ sumOfCargoPlaces }}
      </td>
    </template>
  </v-data-table>
</template>
<script>
import Reference from "../../../components/reference/Reference.vue";
import DecimalEditor from "../../../components/text-fields/DecimalEditor.vue";
import {
  createCategoriesInfo,
  updateCategoriesInfo,
  deleteCategoriesInfo,
} from "../../../backend/goodsDetailsApi.js";

export default {
  components: {
    Reference,
    DecimalEditor,
  },
  props: ["id", "totalInfo", "items", "disabled"],
  data() {
    return {
      headers: [
        { value: "category", text: "Категория товара", sortable: false },
        { value: "volume", text: "Вес брутто, кг", sortable: false },
        { value: "weightBrutto", text: "Объем, м3", sortable: false },
        { value: "cargoPlaces", text: "Всего мест", sortable: false },
        { value: "add", text: "", type: "icon", sortable: false },
      ],
      itemsLoading: false,
    };
  },
  computed: {
    isItemsWithCategory() {
      if (!this.items.length) {
        return false;
      }
      return !!this.items.find(i => i.category === null);
    },
    sumOfVolume() {
      if (!this.items.length) {
        return 0;
      }
      return this.items.reduce(function(sum, current) {
        return sum + current.volume;
      }, 0);
    },
    sumOfWeightBrutto() {
      if (!this.items.length) {
        return 0;
      }
      return this.items.reduce(function(sum, current) {
        return sum + current.weightBrutto;
      }, 0);
    },
    sumOfCargoPlaces() {
      if (!this.items.length) {
        return 0;
      }
      return this.items.reduce(function(sum, current) {
        return sum + current.cargoPlaces;
      }, 0);
    },
    isDifferentSumOfVolume() {
      return (
        this.totalInfo?.totalVolume.toFixed(3) !== this.sumOfVolume.toFixed(3)
      );
    },
    isDifferentSumOfWeightBrutto() {
      return (
        this.totalInfo?.totalWeightBrutto.toFixed(3) !==
        this.sumOfWeightBrutto.toFixed(3)
      );
    },
    isDifferentSumOfCargoPlaces() {
      return this.totalInfo?.totalCargoPlaces !== this.sumOfCargoPlaces;
    },
  },
  methods: {
    async handleItemChange(item) {
      const itemValue = {
        categoryId: item.category?.id,
        weight: item.weightBrutto,
        volume: item.volume,
        cargoPlaces: item.cargoPlaces,
      };

      if (item.id === 0) {
        await createCategoriesInfo(this.id, itemValue);
        this.$emit("change");
        this.showInfo("Информация сохранена");
      } else if (item.id > 0) {
        await updateCategoriesInfo(this.id, item.id, itemValue);
        this.$emit("change");
        this.showInfo("Изменения сохранены");
      } else {
        this.showInfo("Заполните все поля для сохранения");
      }
    },
    addItem() {
      this.items.push({
        id: 0,
        category: null,
        volume: 0,
        weightBrutto: 0,
        cargoPlaces: 0,
      });
      this.$nextTick(() => {
        const element = this.$refs["table-frame"].$el.children[0];
        element.scrollTop = element.offsetHeight;
      });
    },
    async deleteItems(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);

      if (item.id > 0) {
        await deleteCategoriesInfo(this.id, item.id);
        this.$emit("change");
        this.showInfo("Изменения в таблице сохранены");
      }
    },
  },
};
</script>
